import React, { useState, useEffect } from "react"
import { promotionsData } from "../../data/PromotionData"

export default function ModuleKingOfTheReels({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "King of the Reels"
  )

  const [leaderboardData, setLeaderboardData] = useState([])
  const [leaderboardDataGrandWinner, setLeaderboardDataGrandWinner] = useState(
    []
  )
  const [loadingWeekly, setLoadingWeekly] = useState(true)
  const [loadingGrand, setLoadingGrand] = useState(true)
  const [loading, setLoading] = useState(true)
  const bonusByRank = {
    1: 8050,
    2: 3050,
    3: 2000,
    4: 1000,
    5: 150,
    6: 150,
    7: 150,
    8: 150,
    9: 150,
    10: 150,
    // Ranks 11-15 get no bonus, so we can skip them or map to 0
  }
  const bonusByRankGrandWinner = {
    1: 20000, // Grand winner gets ₱10,000
  }
  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getCQ9Leaderboard`
        const response = await fetch(url)
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`)

        const rawData = await response.json()

        const parsedData = Object.entries(rawData).map(([ranking, value]) => {
          const parts = value.split(",")
          const username = parts[0]?.trim()
          const score = parts[1]?.split("|")[1]?.trim() || "0"

          return {
            ranking, // e.g. "1", "2", ...
            username, // e.g. "ANI**0032**"
            score, // e.g. "12345"
          }
        })

        setLeaderboardData(parsedData.slice(0, 10))
      } catch (err) {
        console.error("Error fetching leaderboard data:", err)
      } finally {
        setLoadingWeekly(false)
      }
    }

    fetchLeaderboardData()
  }, [])

  useEffect(() => {
    const fetchLeaderboardDataGrandWinner = async () => {
      try {
        const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getCQ9LeaderboardGrand`
        const response = await fetch(url)
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`)

        const rawData = await response.json()

        const parsedData = Object.entries(rawData).map(([ranking, value]) => {
          const parts = value.split(",")
          const username = parts[0]?.trim()
          const score = parts[1]?.split("|")[1]?.trim() || "0"

          return {
            ranking,
            username,
            score,
          }
        })

        setLeaderboardDataGrandWinner(parsedData.slice(0, 1))
      } catch (err) {
        console.error("Error fetching leaderboard data:", err)
      } finally {
        setLoadingGrand(false)
      }
    }

    fetchLeaderboardDataGrandWinner()
  }, [])

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>
        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>
            <div className="king-of-reel-title">Monthly Grand Draw Winner</div>
            <table
              className="promotion-module-table"
              style={{ marginTop: "5px", marginBottom: "10px" }}
            >
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Player ID</th>
                  <th>Bonus Amount</th>
                </tr>
              </thead>
              <tbody>
                {loadingGrand ? (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardDataGrandWinner.length > 0 ? (
                  leaderboardDataGrandWinner.map((row, index) => {
                    const displayRank = row.ranking // Usually “1” for grand winner
                    const bonusValue = bonusByRankGrandWinner[row.ranking] || 0
                    const bonusDisplay = bonusValue
                      ? `₱${bonusValue.toLocaleString()}`
                      : "–"

                    return (
                      <tr key={index}>
                        <td>{displayRank}</td>
                        <td>{row.username || "---"}</td>
                        <td>{bonusDisplay}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* … earlier code omitted for brevity … */}
            <div className="king-of-reel-title">Weekly Leaderboard</div>
            <table
              className="promotion-module-table"
              style={{ marginTop: "5px" }}
            >
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Player ID</th>
                  <th>Bonus Amount</th>
                </tr>
              </thead>
              <tbody>
                {loadingWeekly ? (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardData.length > 0 ? (
                  leaderboardData.map((row, index) => {
                    // Show medal icons for top 3 if you like:
                    let displayRank = row.ranking
                    if (displayRank === "1") displayRank = "🥇 1"
                    else if (displayRank === "2") displayRank = "🥈 2"
                    else if (displayRank === "3") displayRank = "🥉 3"

                    // Lookup bonus amount by rank:
                    const bonusValue = bonusByRank[row.ranking] || 0
                    // Format as currency or dash if nobody gets a bonus:
                    const bonusDisplay = bonusValue
                      ? `₱${bonusValue.toLocaleString()}`
                      : "–"

                    return (
                      <tr key={index}>
                        <td>{displayRank}</td>
                        <td>{row.username || "---"}</td>
                        <td>{bonusDisplay}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="promotion-module-cta">
            <span style={{ fontSize: "13px", paddingInline: "10px" }}>
              Leaderboard changes in real-time until the final result every
              Monday at 12PM.
            </span>
            <a href="/slots/?provider=CQ9">
              <button className="promotion-module-leaderboard-btn">
                Play Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
